import { HOST } from '../config';
import { apiGet, apiPost, CancelToken } from '../api';

export const A = {
  REQUEST_FIND_CITY: 'REQUEST_FIND_CITY',
  RECEIVE_FIND_CITY: 'RECEIVE_FIND_CITY',
  ERROR_FIND_CITY: 'ERROR_FIND_CITY',

  REQUEST_FIND_ADDRESS: 'REQUEST_FIND_ADDRESS',
  RECEIVE_FIND_ADDRESS: 'RECEIVE_FIND_ADDRESS',
  ERROR_FIND_ADDRESS: 'ERROR_FIND_ADDRESS',

  REQUEST_GET_PACKAGE: 'REQUEST_GET_PACKAGE',
  RECEIVE_GET_PACKAGE: 'RECEIVE_GET_PACKAGE',
  ERROR_GET_PACKAGE: 'ERROR_GET_PACKAGE',

  REQUEST_GET_DELIVERY_VARIANTS: 'REQUEST_GET_DELIVERY_VARIANTS',
  RECEIVE_GET_DELIVERY_VARIANTS: 'RECEIVE_GET_DELIVERY_VARIANTS',
  ERROR_GET_DELIVERY_VARIANTS: 'ERROR_GET_DELIVERY_VARIANTS',

  REQUEST_GET_DEVILERY_POINTS: 'REQUEST_GET_DEVILERY_POINTS',
  RECEIVE_GET_DEVILERY_POINTS: 'RECEIVE_GET_DEVILERY_POINTS',
  ERROR_GET_DEVILERY_POINTS: 'ERROR_GET_DEVILERY_POINTS',

  REQUEST_GET_POINT_DATA: 'REQUEST_GET_POINT_DATA',
  RECEIVE_GET_POINT_DATA: 'RECEIVE_GET_POINT_DATA',
  ERROR_GET_POINT_DATA: 'ERROR_GET_POINT_DATA',

  REQUEST_FIND_STREET: 'REQUEST_FIND_STREET',
  RECEIVE_FIND_STREET: 'RECEIVE_FIND_STREET',
  ERROR_FIND_STREET: 'ERROR_FIND_STREET',

  REQUEST_UPDATE_DELIVERY_RESULT: 'REQUEST_UPDATE_DELIVERY_RESULT',
  RECEIVE_UPDATE_DELIVERY_RESULT: 'RECEIVE_UPDATE_DELIVERY_RESULT',
  ERROR_UPDATE_DELIVERY_RESULT: 'ERROR_UPDATE_DELIVERY_RESULT',

  REQUEST_FIND_COMPANY: 'REQUEST_FIND_COMPANY',
  RECEIVE_FIND_COMPANY: 'RECEIVE_FIND_COMPANY',
  ERROR_FIND_COMPANY: 'ERROR_FIND_COMPANY',

  REQUEST_FIND_REGION: 'REQUEST_FIND_REGION',
  RECEIVE_FIND_REGION: 'RECEIVE_FIND_REGION',
  ERROR_FIND_REGION: 'ERROR_FIND_REGION',
};

export const fetchFindCity = (query, includeForeign = false, country) => {
  return (dispatch, getState) => {
    dispatch(requestFindCity());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/prompter/location?query=${query}&include_foreign=${includeForeign}&country=${country}`,
        domain: getState().auth.account.domains[0].domain,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFindCity());
            resolve(res.suggestions);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindCity(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFindCity(err));
        },
      });
    });
  };
};

const requestFindCity = () => {
  return {
    type: A.REQUEST_FIND_CITY,
  };
};

const receiveFindCity = () => {
  return {
    type: A.RECEIVE_FIND_CITY,
  };
};

const errorFindCity = (err) => {
  return {
    type: A.ERROR_FIND_CITY,
    err,
  };
};

export const fetchFindAddress = (query) => {
  return (dispatch, getState) => {
    dispatch(requestFindAddress());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/prompter/address?query=${query}`,
        domain: getState().auth.account.domains[0].domain,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFindAddress());
            resolve(res.suggestions);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindAddress(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFindAddress(err));
        },
      });
    });
  };
};

const requestFindAddress = () => {
  return {
    type: A.REQUEST_FIND_ADDRESS,
  };
};

const receiveFindAddress = () => {
  return {
    type: A.RECEIVE_FIND_ADDRESS,
  };
};

const errorFindAddress = (err) => {
  return {
    type: A.ERROR_FIND_ADDRESS,
    err,
  };
};

let fetchGetPackageCancel = () => null;

export const fetchGetPackage = (data) => {
  return async (dispatch, getState) => {
    fetchGetPackageCancel();
    dispatch(requestGetPackage());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/products/dimensions`,
        tokens: getState().auth.tokenData,
        cancelToken: new CancelToken(function (cancel) {
          fetchGetPackageCancel = cancel;
        }),
        body: data,
        callback: (res) => {
          dispatch(receiveGetPackage());
          resolve(res);
        },
        error: (err) => {
          dispatch(errorGetPackage(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPackage = () => {
  return {
    type: A.REQUEST_GET_PACKAGE,
  };
};

const receiveGetPackage = (data) => {
  return {
    type: A.RECEIVE_GET_PACKAGE,
    data,
  };
};

const errorGetPackage = (err) => {
  return {
    type: A.ERROR_GET_PACKAGE,
    err,
  };
};

let fetchGetDeliveryVariantsCancel = () => null;

export const fetchGetDeliveryVariants = (data) => {
  return async (dispatch, getState) => {
    fetchGetDeliveryVariantsCancel();
    dispatch(requestGetDeliveryVariants());
    return new Promise((resolve, reject) => {
      apiPost({
        dispatch,
        url: `${HOST}/api/lite/tariffs`,
        body: data,
        tokens: getState().auth.tokenData,
        cancelToken: new CancelToken(function (cancel) {
          fetchGetDeliveryVariantsCancel = cancel;
        }),
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetDeliveryVariants());
            resolve(res.tariffs);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindCity(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetDeliveryVariants(err));
        },
      });
    });
  };
};

const requestGetDeliveryVariants = () => {
  return {
    type: A.REQUEST_GET_DELIVERY_VARIANTS,
  };
};

const receiveGetDeliveryVariants = (data) => {
  return {
    type: A.RECEIVE_GET_DELIVERY_VARIANTS,
    data,
  };
};

const errorGetDeliveryVariants = (err) => {
  return {
    type: A.ERROR_GET_DELIVERY_VARIANTS,
    err,
  };
};

export const fetchGetDeliveryPoints = (data) => {
  return (dispatch, getState) => {
    dispatch(requestGetDeliveryPoints());
    return new Promise((resolve, reject) => {
      apiPost({
        body: data,
        url: `${HOST}/api/lite/delivery_points`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetDeliveryPoints());
            resolve(res.list);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetDeliveryPoints(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetDeliveryPoints(err));
        },
      });
    });
  };
};

const requestGetDeliveryPoints = () => {
  return {
    type: A.REQUEST_GET_DEVILERY_POINTS,
  };
};

const receiveGetDeliveryPoints = (data) => {
  return {
    type: A.RECEIVE_GET_DEVILERY_POINTS,
    data,
  };
};

const errorGetDeliveryPoints = (err) => {
  return {
    type: A.ERROR_GET_DEVILERY_POINTS,
    err,
  };
};

export const fetchGetPointData = (data) => {
  return (dispatch, getState) => {
    dispatch(requestGetPointData());
    return new Promise((resolve, reject) => {
      apiPost({
        body: data,
        url: `${HOST}/api/lite/delivery_point`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPointData(res.list[0]));
            resolve(res.list[0]);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPointData(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPointData(err));
        },
      });
    });
  };
};

const requestGetPointData = () => {
  return {
    type: A.REQUEST_GET_POINT_DATA,
  };
};

const receiveGetPointData = (point) => {
  return {
    type: A.RECEIVE_GET_POINT_DATA,
    point,
  };
};

const errorGetPointData = (err) => {
  return {
    type: A.ERROR_GET_POINT_DATA,
    err,
  };
};

export const fetchFindStreet = (query) => {
  return (dispatch, getState) => {
    dispatch(requestFindStreet());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/prompter/street?query=${query}`,
        domain: getState().auth.account.domains[0].domain,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFindStreet());
            resolve(res.suggestions);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindStreet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFindStreet(err));
          reject(err);
        },
      });
    });
  };
};

const requestFindStreet = () => {
  return {
    type: A.REQUEST_FIND_STREET,
  };
};

const receiveFindStreet = () => {
  return {
    type: A.RECEIVE_FIND_STREET,
  };
};

const errorFindStreet = (err) => {
  return {
    type: A.ERROR_FIND_STREET,
    err,
  };
};

export const fetchUpdateDeliveryResult = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateDeliveryResult());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/delivery_result`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateDeliveryResult());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(receiveUpdateDeliveryResult(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateDeliveryResult(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateDeliveryResult = () => {
  return {
    type: A.REQUEST_UPDATE_DELIVERY_RESULT,
  };
};

const receiveUpdateDeliveryResult = (data) => {
  return {
    type: A.RECEIVE_UPDATE_DELIVERY_RESULT,
    data,
  };
};

const errorUpdateDeliveryResult = (err) => {
  return {
    type: A.ERROR_UPDATE_DELIVERY_RESULT,
    err,
  };
};

export const fetchFindCompany = (query) => {
  return (dispatch, getState) => {
    dispatch(requestFindCompany());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/settings/prompter/company?query=${query}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFindCompany());
            resolve(res.suggestions);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindCompany(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFindCompany(err));
        },
      });
    });
  };
};

const requestFindCompany = () => {
  return {
    type: A.REQUEST_FIND_COMPANY,
  };
};

const receiveFindCompany = () => {
  return {
    type: A.RECEIVE_FIND_COMPANY,
  };
};

const errorFindCompany = (err) => {
  return {
    type: A.ERROR_FIND_COMPANY,
    err,
  };
};

export const fetchFindRegion = (query) => {
  return (dispatch, getState) => {
    dispatch(requestFindRegion());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/prompter/region?query=${query}`,
        domain: getState().auth.account.domains[0].domain,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveFindRegion());
            resolve(res.suggestions);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorFindRegion(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorFindRegion(err));
          reject(err);
        },
      });
    });
  };
};

const requestFindRegion = () => {
  return {
    type: A.REQUEST_FIND_REGION,
  };
};

const receiveFindRegion = () => {
  return {
    type: A.RECEIVE_FIND_REGION,
  };
};

const errorFindRegion = (err) => {
  return {
    type: A.ERROR_FIND_REGION,
    err,
  };
};

export const fetchGetPrompterCountries = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/prompter/countries`,
        domain: getState().auth.account.domains[0].domain,
        callback: (res) => {
          resolve(res.countries);
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};
